

export class QueuedTasks {
    queue: Object[] = [];
    cancelled: Object[] = [];
    totalActive: number = 0;
    maxConcurrencyLimit: number;
    totalItems: number;
    action: Function;
    resetAction: Function;

    constructor(maxConcurrencyLimit = 0, totalItems = 0) {
        this.maxConcurrencyLimit = maxConcurrencyLimit;
        this.totalItems = totalItems;
    }

    add(item) {
        var q = this.queue;
        if (!this.isCancelled(item.itemId) && q.indexOf(item) == -1) {
            q.push(item);
        }

    }

    done(itemId, deactivate?) {
        this.clearCancelled(itemId);
        this.totalItems--;
        if (!!deactivate)
            this.totalActive--;
    }

    cancel(item) {
        var q = this.cancelled;
        if (q.indexOf(item) == -1)
            q.push(item);
    }

    clearCancelled(item?) {
        var c = this.cancelled;
        if (!!item) {
            let ind = c.indexOf(item);
            if (ind != -1) {
                c.splice(ind, 1);
            }
        } else {
            this.cancelled = [];
        }
    }

    getNext() {
        this.totalActive++;
        //It will remove the returned item from queue automatically
        return this.queue.shift();
    }

    isPending() {
        return this.queue.length > 0;
    }

    isCancelled(item) {
        return this.cancelled.indexOf(item) != -1;
    }

    itemInQueue(item) {
        let ind = this.queue.findIndex(q => q.itemId == item);
        return ind != -1;
    }

    //Handles the queuing of the tasks
    runTask = () => {
        let context = this;
        const IDLE_DELAY = 500;

        if (context.isPending() && context.totalActive < context.maxConcurrencyLimit) {
            var item = context.getNext();
            //  console.log('Processing ' + item + ' Total Active Items ' + context.tasks.totalActive);
            context.action(item);
            context.runTask();
        } else if (!!context.maxConcurrencyLimit && context.totalActive >= context.maxConcurrencyLimit) {
            //  console.log('Hold State');
            setTimeout(function () { context.runTask(); }, IDLE_DELAY);
        } else {
            if (context.totalItems > 0 || context.isPending()) {
                //console.log("Runing : ",context.totalItems );
                setTimeout(function () {
                    context.runTask();
                }, IDLE_DELAY);
            } else {
                console.log('End Run Task');
                context.resetAction();
            }
        }
    }
}

